import { Component } from '@angular/core';

@Component({
  selector: 'auth-layout',
  template: '<router-outlet></router-outlet>'
})
export class AuthLayoutComponent {}
